import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { Provider } from 'react-redux';

import { queryClient } from '@/lib/query-client';
import { store } from '@/lib/store';
import { Toaster as SonnerToaster } from '@/components/ui/sonner';
import { Toaster as CustomToaster } from '@/components/ui/toaster';

function providers({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        {children}
        <SonnerToaster
          theme='light'
          position='top-right'
          richColors
          icons={{
            success: <CircleCheckIcon className='size-4' />,
            info: <InfoIcon className='size-4' />,
            warning: <TriangleAlertIcon className='size-4' />,
            error: <OctagonXIcon className='size-4' />,
            loading: <Loader2Icon className='size-4 animate-spin' />,
          }}
        />
        <CustomToaster />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Provider>
  );
}

export default providers;
